import * as React from 'react';

import Editor from './Editor';
import Widget from './Widget';
import WidgetContainer from './WidgetContainer';
import ISettings from './ISettings';

export {
    Editor,
    Widget,
    WidgetContainer,
    ISettings,
};


// WEBPACK FOOTER //
// ./src/components/widget/basic/pagebreak/index.ts